/**
 * 格式化时间
 *
 * @param {String} str
 * @returns 格式化后的时间
 */
export const formatDate = str => {
  if (!str) return ''
  const date = new Date(str)
  const time = new Date().getTime() - date.getTime() // 现在的时间-传入的时间 = 相差的时间（单位 = 毫秒）
  if (time < 0) {
    return ''
  } else if (time / 1000 < 30) {
    return '刚刚'
  } else if (time / 1000 < 60) {
    return parseInt(time / 1000) + '秒前'
  } else if (time / 60000 < 60) {
    return parseInt(time / 60000) + '分钟前'
  } else if (time / 3600000 < 24) {
    return parseInt(time / 3600000) + '小时前'
  } else if (time / 86400000 < 31) {
    return parseInt(time / 86400000) + '天前'
  } else if (time / 2592000000 < 12) {
    return parseInt(time / 2592000000) + '月前'
  } else {
    return parseInt(time / 31536000000) + '年前'
  }
}

/**
 * 时间戳转时间
 * @param val 传入的时间戳
 * @param type 需要转换的类型  YYYY-MM-DD ： 只需要日期 ； YYYY-MM-DD HH:MM:SS ： 日期加时分秒
 * 如只需要如期，则startNum ： 0 ， endNum ： 10
 */
export const transitionTimestamp = (val, type) => {
  val = val * 1 < 100000000000 ? val * 1000 : val // 当不是毫秒时候，转换为毫秒

  const date = new Date(val)
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  const hour = ('0' + date.getHours()).slice(-2)
  const minute = ('0' + date.getMinutes()).slice(-2)
  const second = ('0' + date.getSeconds()).slice(-2)

  switch (type) {
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`
    case 'HH:MM:SS':
      return `${hour}:${minute}:${second}`
    default:
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  }
}
/**
 * Date类型格式化
 * @param date 传入的Date
 * @param type 需要转换的类型  YYYY-MM-DD ： 只需要日期 ； YYYY-MM-DD HH:MM:SS ： 日期加时分秒
 * 如只需要如期，则startNum ： 0 ， endNum ： 10
 */
export const transitionDate = (date, type) => {
  const year = date.getFullYear()
  const month =
    date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1
  const day =
    date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hour =
    date.getHours() * 1 < 10 ? '0' + date.getHours() : date.getHours()
  const minute =
    date.getMinutes() * 1 < 10
      ? '0' + date.getMinutes()
      : date.getMinutes()
  const second =
    date.getSeconds() * 1 < 10
      ? '0' + date.getSeconds()
      : date.getSeconds()

  switch (type) {
    case 'YYYY-MM':
      return `${year}-${month}`
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`
    case 'YYYY-MM-DD HH:MM:SS':
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  }
}
/**
 * Data格式化
 * @param time time 传入的Date
 * @param type 需要转换的类型  YYYY-MM-DD ： 只需要日期 ； YYYY-MM-DD HH:MM:SS ： 日期加时分秒
 * @returns {string}
 */
export const transitDate = (time, type) => {
  var date = new Date(time)
  const year = date.getFullYear()
  const month =
    date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1
  const day =
    date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hour =
    date.getHours() * 1 < 10 ? '0' + date.getHours() : date.getHours()
  const minute =
    date.getMinutes() * 1 < 10
      ? '0' + date.getMinutes()
      : date.getMinutes()
  const second =
    date.getSeconds() * 1 < 10
      ? '0' + date.getSeconds()
      : date.getSeconds()

  switch (type) {
    case 'YYYY-MM':
      return `${year}-${month}`
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`
    case 'YYYY-MM-DD HH:MM:SS':
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  }
}
